// @ts-strict-ignore
import type { Options, SeriesSplineOptions } from "highcharts";

/**
 * Replaces the default Highcharts hamburger icon with three vertical dots,
 * keeping the menu button consistent with IconButton styling.
 */
export const highchartsEllipsisContextButtonOptions: Record<string, any> = {
  contextButton: {
    symbol: null,
    useHTML: true,
    text: '<div style="display: flex; align-items: center; justify-content: center; width: 28px; height: 28px"><i class="fa fa-ellipsis-v fa-lg" style="color:#5e6c75"></i></div>',
    theme: {
      stroke: "#fff",
      states: {
        hover: { fill: "#e9ebed" },
        select: { fill: "#e9ebed", stroke: "#75dbe7" },
      },
    },
  },
};

/**
 * This is the highcharts config used by campaign message stats and workflow steps
 */
export interface BaseChartConfig {
  getConfig: () => Options;
  // the type is not set nor is it required. They just arbitrarily added it for TS typing
  series?: Omit<SeriesSplineOptions, "type">;
}

/**
 * @note this takes the shape of an object with `getConfig` property because it replaces
 *   a legacy library function (you can see instances of this by doing global-find of
 *   `getConfig`)
 */
export const baseChartConfig: BaseChartConfig = {
  /**
   * returns a basic chart configuration for histograms used in Dashboard
   */
  getConfig: () => ({
    title: {
      text: null,
    },
    chart: {
      type: "spline",
      margin: [40, 50, 25, null],
      height: 350,
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
    },
    legend: {
      enabled: false,
    },
    exporting: {
      buttons: {
        contextButton: {
          x: -40,
          y: 0,
        },
      },
    },
  }),
};

export const shortChartConfig: BaseChartConfig = {
  /*
   * returns a basic chart configuration for tile charts used in Dashboard
   */
  getConfig: () => ({
    legend: {
      enabled: false,
    },
    title: {
      text: null,
    },
    yAxis: {
      visible: false,
      maxPadding: 0,
    },
    xAxis: {
      type: "datetime",
      visible: false,
    },
    chart: {
      height: 75,
      margin: [1, -5, 1, -5],
    },
    exporting: {
      enabled: false,
    },
  }),
};
